import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import styled from 'styled-components';

import { getLanguageCode, useLocalizedEvents } from '../utils';

import Grid from './Grid';
import Cell from './Cell';
import Block from './Block';
import H4 from './H4';
import H5 from './H5';
import P from './P';
import Image from './Image';

const DateBlock = styled(Block)`
  z-index: 1;
`;

const EventsList = ({ selectedLocale, excludeUid, withTitle }) => {
  const { events, list } = useLocalizedEvents(selectedLocale);

  const filteredEvents = events.filter(
    ({ node: { uid } }) => uid !== excludeUid,
  );

  return (
    <Grid>
      {withTitle ? (
        <Cell size={1} p="baseUnit">
          <H4>{list[0].node.data.title.text}</H4>
        </Cell>
      ) : null}

      {filteredEvents.length > 0 ? (
        <>
          {filteredEvents.map(({ node: { uid, data: event } }) => (
            <Cell
              key={`event-item-${uid}`}
              size={{
                mobile: 1,
                smallTablet: 1 / 2,
                tablet: 1 / 3,
              }}
            >
              <Block
                px="baseUnit"
                mb={{ mobile: 'baseUp4', smallTablet: '0' }}
                position="relative"
              >
                <DateBlock
                  position="absolute"
                  backgroundColor="orange"
                  px="baseUnit"
                >
                  <H4 textAlign="center" color="white" pt="baseDown2">
                    {event.date.split(',')[0]}
                    <br />
                    {event.date.split(',')[1].toLowerCase()}
                  </H4>
                </DateBlock>
                <Image content={event.image} />

                <Block my="baseUp2">
                  <H5 color="coral" mb="baseUnit">
                    {event.title.text}
                  </H5>
                  <P>{event.short_description.text}</P>
                  <P color="coral">
                    <Link
                      to={`${
                        selectedLocale !== 'en-us'
                          ? `/${getLanguageCode(selectedLocale)}`
                          : ''
                      }/events/${uid}`}
                    >
                      {event.read_more_text.text} &gt;
                    </Link>
                  </P>
                </Block>
              </Block>
            </Cell>
          ))}
        </>
      ) : (
        <Cell size={1}>
          <P p="baseUnit">{list[0].node.data.no_events.text}</P>
        </Cell>
      )}
    </Grid>
  );
};

EventsList.defaultProps = {
  excludeUid: '',
  withTitle: true,
};

EventsList.propTypes = {
  selectedLocale: PropTypes.string.isRequired,
  excludeUid: PropTypes.string,
  withTitle: PropTypes.bool,
};

export default EventsList;
